import { cn } from '../../lib/utils';
import './ui.css';

export function Label({ className, ...props }) {
  return <label className={cn('ui-label', className)} {...props} />;
}
